import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Grid} from 'views/components';

import List from './list/List';

import {generateFilterOptions} from 'views/scenes/career/job_list/scene/filter/FilterGenerator';

const filterOptions = generateFilterOptions();

const buildDefaultSelection = (clientFilter) => {
  const baseSelection = {
    order: {orderBy: 'creationTime', orderDirc: 'DESC'},
    filter: {
      status: {
        filterData: filterOptions['status'],
        optionSelected: ['ACTIVE', 'INACTIVE'],
      },
    },
  };

  if (!clientFilter) {
    return baseSelection;
  }

  return {
    ...baseSelection,
    filter: {
      ...baseSelection.filter,
      [clientFilter.key]: {
        filterData: {
          key: clientFilter.key,
        },
        optionSelected: clientFilter.value,
      },
    },
  };
};

const Career = (props) => {
  const clientData = props.clientData;
  const clientFilter = React.useMemo(() => {
    return {key: 'clientRn', value: clientData.clientRn};
  }, [clientData]);

  const [reload, setReload] = React.useState(0);
  const selection = React.useMemo(() => buildDefaultSelection(clientFilter), [clientFilter]);

  return (
    <Grid container spacing={1} p={2}>
      <Grid item xs={12}>
        <List
          selection={selection}
          reload={reload}
          setReload={setReload}
        />
      </Grid>
    </Grid>
  );
};

Career.propTypes = {
  clientData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(Career));
